import React, { useCallback } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Icon } from "@zorni/components-lib";
import styles from "./MobileBottomNav.module.css";
import { useZorni } from "../../hooks/useZorni";
import { useNotifications } from "../../hooks/NotificationContext";
import useMobile from "../../hooks/useMobile";

const MobileBottomNav = () => {
  // Téléphone uniquement : les tablettes (iPad mini compris) n'ont pas la
  // barre de navigation basse, réservée aux écrans étroits.
  const isMobile                      = useMobile(599);
  const navigate                      = useNavigate();
  const location                      = useLocation();
  const { isAuthenticated, keycloak } = useZorni();
  const { hasNewMessages, hasNewReservations } = useNotifications();

  const connectedItems = [
    { id: "home",      icon: "iconMap",              label: "Explorer", path: "/",          onClick: () => navigate("/") },
    { id: "favorites", icon: "iconFavoriteRegular",  label: "Favoris",  path: "/favorites", onClick: () => navigate("/favorites") },
    { id: "trips",     icon: "iconSuitcase",         label: "Voyages",  path: "/my-trips",  onClick: () => navigate("/my-trips"), badge: hasNewReservations, badgeLabel: "Nouvelle réservation" },
    { id: "messages",  icon: "iconEnvelope",         label: "Messages", path: "/messenger", onClick: () => navigate("/messenger"), badge: hasNewMessages, badgeLabel: "Nouveau message" },
    { id: "profil",    icon: "iconUser",             label: "Profil",   path: "/profil",    onClick: () => navigate("/profil") },
  ];

  const guestItems = [
    { id: "home",  icon: "iconMap",  label: "Explorer",  path: "/",   onClick: () => navigate("/") },
    { id: "login", icon: "iconUser", label: "Connexion", path: null,  onClick: () => keycloak.login() },
  ];

  const items = isAuthenticated ? connectedItems : guestItems;

  const isActive = useCallback(
    (path) => {
      if (!path) return false;
      if (path === "/") return location.pathname === "/";
      return location.pathname.startsWith(path);
    },
    [location.pathname]
  );

  if (!isMobile) return null;

  return (
    <div className={styles.navWrapper}>
      <nav className={styles.nav} aria-label="Navigation principale">
        {items.map((item) => {
          const active = item.path ? isActive(item.path) : false;
          return (
            <button
              key={item.id}
              className={`${styles.item} ${active ? styles.active : ""}`}
              onClick={item.onClick}
              aria-label={item.label}
              aria-current={active ? "page" : undefined}
            >
              <span className={styles.iconWrap}>
                {item.badge && <span className={styles.badge} aria-label={item.badgeLabel} />}
                <Icon name={item.icon} size="md" />
              </span>
              <span className={styles.label}>{item.label}</span>
            </button>
          );
        })}
      </nav>
    </div>
  );
};

export default MobileBottomNav;
